// GA4 e-commerce event helpers.
// Safe no-op if gtag is not loaded (e.g. env var missing).
// Set REACT_APP_GA_DEBUG=1 to also console.debug every event fired.

const hasGtag = () => typeof window !== "undefined" && typeof window.gtag === "function";
const DEBUG = process.env.REACT_APP_GA_DEBUG === "1";

export const trackEvent = (name, params = {}) => {
  if (DEBUG) console.debug("[GA4]", name, params);
  if (!hasGtag()) return;
  window.gtag("event", name, params);
};

// Fires when the user submits the booking form and initiates checkout.
export const trackBeginCheckout = ({ bookingId, packageId, packageName, amountInr, category, quantity = 1 }) => {
  const params = {
    transaction_id: bookingId,
    currency: "INR",
    value: Number(amountInr) || 0,
    items: [
      {
        item_id: packageId,
        item_name: packageName,
        item_category: category || "Tour Package",
        price: Number(amountInr) || 0,
        quantity,
      },
    ],
  };
  if (DEBUG) console.debug("[GA4] begin_checkout", params);
  if (!hasGtag()) return;
  window.gtag("event", "begin_checkout", params);
};

// Fires on payment-success page once the booking is confirmed.
export const trackPurchase = ({ bookingId, packageId, packageName, amountInr, category, quantity = 1 }) => {
  const params = {
    transaction_id: bookingId,
    currency: "INR",
    value: Number(amountInr) || 0,
    items: [
      {
        item_id: packageId,
        item_name: packageName,
        item_category: category || "Tour Package",
        price: Number(amountInr) || 0,
        quantity,
      },
    ],
  };
  if (DEBUG) console.debug("[GA4] purchase", params);
  if (!hasGtag()) return;
  window.gtag("event", "purchase", params);
};
